import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { BlueprintLibraryPage } from "@/features/ZeroAdmin/blueprints/BlueprintLibraryPage";
import { blueprintReviewSearchSchema } from "@/features/ZeroAdmin/blueprints/library";

export const Route = createFileRoute(
  "/_auth/settings/$siteId/_zeroAdmin/blueprints/",
)({
  component: BlueprintLibraryRoute,
  validateSearch: zodValidator(blueprintReviewSearchSchema),
  search: { middlewares: [retainSearchParams(["device"])] },
});

function BlueprintLibraryRoute() {
  const { siteId } = Route.useParams();
  const { device = "mobile" } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <BlueprintLibraryPage
      siteId={siteId}
      device={device}
      onDeviceChange={(next) =>
        void navigate({ search: { device: next }, replace: true })
      }
    />
  );
}
